import { render, staticRenderFns } from "./employeeUserForm.vue?vue&type=template&id=720a129a&scoped=true"
import script from "./employeeUserForm.vue?vue&type=script&lang=js"
export * from "./employeeUserForm.vue?vue&type=script&lang=js"
import style0 from "./employeeUserForm.vue?vue&type=style&index=0&id=720a129a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720a129a",
  null
  
)

export default component.exports